"use client"

import React from "react"
import { Box, CircularProgress, Typography } from "@mui/material"


const LoadingSpinner = ({ message = "Loading...", size = 40, fullScreen = false }) => {
  const containerStyle = fullScreen
    ? {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(8px)",
        zIndex: 9999,
      }
    : {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px",
      }

  return (
    <div style={containerStyle}>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
        <CircularProgress
          size={size}
          sx={{
            color: "primary.main",
            "& .MuiCircularProgress-circle": {
              strokeLinecap: "round",
            },
          }}
        />
        <Typography variant="body1" color="text.secondary" fontWeight={600} sx={{ textAlign: "center" }}>
          {message}
        </Typography>
      </Box>
    </div>
  )
}

export default LoadingSpinner